const React = require("react");
const T = React.PropTypes;

require("./Page.less");

const PageType = require("~/types/Page.js").PropType;
const QuestionType = require("~/types/Question.js").PropType;

const Section = require("../Section/Section.jsx");
const ProgressBar = require("../ProgressBar/ProgressBar.jsx");

const Config = require("~/config.js"); 

const Page = React.createClass({
    propTypes: {
        SurveyIDPath: T.arrayOf(T.string).isRequired,
        CurrentSectionGUID: T.string.isRequired,
        Page: PageType.isRequired,
        IsReadOnly: T.bool.isRequired,
        QuestionSnapshot: T.arrayOf(QuestionType).isRequired
    },
    render() {
        const pageIDPath = this.props.SurveyIDPath.concat(this.props.Page.GUID);
        
        const section = this.props.Page.Sections.find((s) => {
            return s.GUID === this.props.CurrentSectionGUID;
        });
        
        const sectionIndex = this.props.Page.Sections.indexOf(section);        

        const previousSectionID = this.GetPreviousSectionID(sectionIndex);
        const nextSectionID = this.GetNextSectionID(sectionIndex);        

        return (<div className="cs-Page">
            <Section key={section.GUID}
                     Section={section}
                     PageIDPath={pageIDPath}
                     IsReadOnly={this.props.IsReadOnly}
                     PreviousSectionID={previousSectionID}
                     NextSectionID={nextSectionID}
                     QuestionSnapshot={this.props.QuestionSnapshot} />
        </div>);
    },
    GetPreviousSectionID(fromIndex) {
        if (fromIndex === 0) {
            return null;
        }

        const result = this.props.Page.Sections[fromIndex - 1].GUID;

        return result;
    },
    GetNextSectionID(fromIndex) {
        if (this.props.Page.Sections.length === fromIndex + 1) {
            return Config.ConfirmationPage;
        }

        const result = this.props.Page.Sections[fromIndex + 1].GUID;

        return result;
    },
    /**
     * Currently unused.
     * This could be used like this, however:
     *
     *   const questionCounts = this.GetQuestionCounts();
     *
     *   <ProgressBar CompletedCount={questionCounts.Completed} 
     *                TotalCount={questionCounts.Total} />
     */
    GetQuestionCounts() {
        const defaultAggregate = {
            Completed: 0,
            Total: 0
        };

        const counts = this.props.Page.Sections.reduce((agg, sec) => {
            const secCounts = sec.Questions.reduce((secAgg, q) => {
                const toAdd = q.ValidationStatus.IsValid ? 1 : 0;

                return {
                    Completed: secAgg.Completed + toAdd,
                    Total: secAgg.Total + 1
                };
            }, defaultAggregate);

            return {
                Completed: agg.Completed + secCounts.Completed,
                Total: agg.Total + secCounts.Total
            }
        }, defaultAggregate);

        return counts;
    }
});

module.exports = Page;


// WEBPACK FOOTER //
// ./src/components/Page/Page.jsx